export default "__VITE_ASSET__2f494694__"